export default {
   email: "info@jugendfarm-er.de"
};